export default {
  namespaced: true,
  inventory_brand_catalog: {
    menu: "Brand catalog",
    title: "Brand",
    name: "Name",
    created_at: "Created",
    updated_at: "Updated",
  },
};
